import React, { useState, useEffect } from "react";
import { ListGroup } from "react-bootstrap";
import { useSelector } from "react-redux";
import TopNavigation from "../../components/TopNavigation";
import * as Assets from "../../utils/svg_assets";
import * as PageRoutes from "../../utils/route_pages";
import { NavLink, useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import { ConfirmationDialog } from "../../components/DialogCollection";
import { Base } from "../../components/RootLayout";
import { getIconFromOrg } from "../../utils/utilities";
import { getLocalStorage } from "../../utils/utilities";
import "./style.scss";

const SettingPage = (props) => {
  const navigate = useNavigate();
  const { login, listBlock } = props;
  const [openLogoutDialog, setOpenLogoutDialog] = useState(false);
  const [NumberBlock, setNumberBlock] = useState(false);
  const orgData = useSelector((state) => state.LoginSM.orgData);

  const handleLogout = async () => {
    const slug = getLocalStorage("slug");
    await props.logout();

    if (slug) {
      navigate(`${PageRoutes.loginOrgBySlug}/${slug}`, { replace: true });
    } else {
      navigate(PageRoutes.login, { replace: true });
    }
  };
  useEffect(() => {
    listBlock().then(function (result) {
      if (result.status === 200) {
        setNumberBlock(result.data.length);
      } else {
        toast.error("Kesalahan pada sistem", {
          position: toast.POSITION.BOTTOM_LEFT,
        });
      }
    });
  }, []);
  return (
    <Base>
      <TopNavigation
        titlePage="Setting"
        toPath={PageRoutes.account}
        setBorder={true}
        showRightIcon={false}
        iconLeft={Assets.iconBack}
        iconRight={Assets.iconFilter}
      />
      <div className="header-list-group-setting">Profile</div>
      <ListGroup>
        <ListGroup.Item>
          <img
            src={
              Object.keys(orgData).length > 0
                ? getIconFromOrg(orgData, "icon_account_setting_edit")
                : Assets.iconEditActive
            }
            className="icon-list p-1"
            alt="edit"
          />
          <NavLink to={PageRoutes.editProfile}>Edit Profile</NavLink>
        </ListGroup.Item>
        {login?.organization_auto_active_user ? null : (
          <ListGroup.Item>
            <img
              src={
                Object.keys(orgData).length > 0
                  ? getIconFromOrg(
                    orgData,
                    "icon_account_setting_change_password"
                  )
                  : Assets.iconLock
              }
              className="icon-list p-1"
              alt="lock"
            />
            <NavLink to={PageRoutes.changePassword}>Change Password</NavLink>
          </ListGroup.Item>
        )}
        <ListGroup.Item>
          <img
            src={Assets.iconBlockUser}
            className="icon-list p-1"
            alt="edit"
          />
          <NavLink to={PageRoutes.blocklist}>Blocked Users</NavLink>
          {
            NumberBlock > 0 ? <button className="float-end circle">{NumberBlock}</button>:""
          }
        </ListGroup.Item>
      </ListGroup>

      <div className="header-list-group-setting">Other</div>
      <ListGroup>
        <ListGroup.Item>
          <img
            src={
              Object.keys(orgData).length > 0
                ? getIconFromOrg(orgData, "icon_account_setting_support")
                : Assets.iconSupportActive
            }
            className="icon-list p-1"
            alt="policy"
          />{" "}
          <NavLink to={PageRoutes.support}> {`Support`}</NavLink>
        </ListGroup.Item>
        <ListGroup.Item>
          <img
            src={
              Object.keys(orgData).length > 0
                ? getIconFromOrg(orgData, "icon_account_setting_privacy_policy")
                : Assets.iconPolicy
            }
            className="icon-list p-1"
            alt="policy"
          />{" "}
          <NavLink to={PageRoutes.privacy_policy}> {`Privacy Policy`}</NavLink>
        </ListGroup.Item>
        <ListGroup.Item>
          <img
            src={
              Object.keys(orgData).length > 0
                ? getIconFromOrg(
                  orgData,
                  "icon_account_setting_term_and_conditions"
                )
                : Assets.iconPolicy
            }
            className="icon-list p-1"
            alt="tnc"
          />
          <NavLink to={PageRoutes.terms_and_condition}>
            {" "}
            {`Term & Condition`}
          </NavLink>
        </ListGroup.Item>
      </ListGroup>
      {login?.organization_auto_active_user ? null : (
        <>
          <div className="header-list-group-setting"></div>
          <ListGroup>
            <ListGroup.Item onClick={() => setOpenLogoutDialog(true)}>
              <img
                src={
                  Object.keys(orgData).length > 0
                    ? getIconFromOrg(orgData, "icon_account_setting_logout")
                    : Assets.iconLogoutActive
                }
                className="icon-list p-1"
                alt="logout"
              />{" "}
              Logout
            </ListGroup.Item>
          </ListGroup>
        </>
      )}
      <ConfirmationDialog
        cancelLabel="Cancel"
        confirmLabel="Logout"
        message="Are you sure you want to log out on this device?"
        show={openLogoutDialog}
        onCancel={() => {
          setOpenLogoutDialog(false);
        }}
        onConfrim={() => handleLogout()}
      />
    </Base>
  );
};

const mapStateToProps = (state) => ({
  login: state.LoginSM.login,
});

const mapDispatchToProps = (dispath) => ({
  logout: dispath.LoginSM.logout,
  listBlock: dispath.BlockSM.getList,
});

export default connect(mapStateToProps, mapDispatchToProps)(SettingPage);
